export const APPSTORE_LINK = "https://apps.apple.com/app/id1022341873";
export const PLAYSTORE_LINK = "https://play.google.com/store/apps/details?id=com.biddl.biddl";
export const UNIVERSAL_APP_LINK = "https://blidz.app.link/download/web";
